import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './SpinnerDots.module.scss'
const cx = cn.bind(s)

interface ISpinnerDotsProps {
	className?: string
	wrapperClassName?: string
	position?: 'center'
	/** s - small; m - middle; l - large */
	size?: 's' | 'm' | 'l'
}

const sizesMap = {
	s: [30, 6],
	m: [60, 12],
	l: [90, 18],
} as const

const SpinnerDots: FC<ISpinnerDotsProps> = ({
	className,
	wrapperClassName,
	position,
	size = 's',
}) => {
	const [width, height] = sizesMap[size]
	const inner = (
		<svg
			className={cx('fade-out', className)}
			width={width}
			height={height}
			viewBox="0 0 30 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<circle opacity="0.4" cx="3" cy="3" r="3" fill="#4673EC" />
			<circle opacity="0.7" cx="15" cy="3" r="3" fill="#4673EC" />
			<circle cx="27" cy="3" r="3" fill="#4673EC" />
		</svg>
	)
	if (position) return <div className={cx('wrapper', wrapperClassName)}>{inner}</div>
	return inner
}

SpinnerDots.displayName = 'SpinnerDots'

export default SpinnerDots
